import React, {ComponentType, memo} from 'react';

import {buildMarkdownTokens} from '../../../src/services/markdown';
import {MarkdownTokenFormatterProps, NodeTransform} from './markdownFormatterTypes';
import {MarkdownTokensFormatter} from './markdownTokensFormatter';

/*
 * Props.
 */

interface MarkdownFormatterProps {
  formatter: ComponentType<MarkdownTokenFormatterProps>;
  text: string;
  transform?: NodeTransform;
  onLinkClick?: (link: string, shiftKey?: boolean) => void;
}

/*
 * Component.
 */

export const MarkdownFormatter = memo<MarkdownFormatterProps>((props) => {
  // Build the markdown tokens for the provided text.
  const {text, transform, onLinkClick, formatter} = props;
  const tokens = buildMarkdownTokens(text);

  // Render the tokens.
  return (
    <MarkdownTokensFormatter
      formatter={formatter}
      tokens={tokens}
      transform={transform}
      onLinkClick={onLinkClick}
    />
  );
});
